import { AgxCollapsible, AgxSpacer } from '@urbanx/agx.ui-components2';
import AutomationFailureDetailRow from './AutomationFailureDetailRow';

interface AutomationFailureDiagnosticsProps {
  entries: [string, string][];
}

const AutomationFailureDiagnostics = ({ entries }: AutomationFailureDiagnosticsProps) => (
  <AgxCollapsible
    title="Developer references"
    variant="withoutDivider"
    backgroundColor="none"
    enableToggle
    showBorder
    headerPadding={{ top: 'md', bottom: 'md', left: 'lg', right: 'lg' }}
    contentPadding={{ top: '3xs', bottom: 'md', left: 'lg', right: 'lg' }}
    content={
      <AgxSpacer direction="vertical" fill>
        {entries.map(([label, value], index) => (
          <AutomationFailureDetailRow
            key={`${label}-${index}`}
            id={`automation-failure-diagnostic-${index}`}
            label={label}
            compact
          >
            <span className="automationFailureCode">{value}</span>
          </AutomationFailureDetailRow>
        ))}
      </AgxSpacer>
    }
  />
);

export default AutomationFailureDiagnostics;
